import React from 'react';
import { StickerDesign } from '../utils/Primitives';

interface PublishedStickerListProps {
  stickers: StickerDesign[];
}

const PublishedStickerList: React.FC<PublishedStickerListProps> = ({ stickers }) => {
  return (
    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', width: '100%' }}>
      {stickers.map((sticker) => (
        <div key={sticker.id} style={{
          marginBottom: '20px',
          backgroundColor: '#f0f0f0',
          borderRadius: '10px',
          padding: '15px',
          width: '300px',
          textAlign: 'center',
          color: '#333333'
        }}>
          <div style={{ fontSize: '1.2em', fontWeight: 'bold', marginBottom: '10px' }}>{sticker.name}</div>
          <div style={{ marginBottom: '5px' }}>Sticker ID: {sticker.id}</div>
          <div style={{ paddingBottom: '5px' }}>{new Date(sticker.publishedAt).toLocaleString()}</div>
        </div>
      ))}
    </div>
  );
};

export default PublishedStickerList;
